import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, MapPin } from 'lucide-react';
import { siteInfo } from '../data/siteData';

export const Footer = () => {
  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Elezioni Comunali", path: "/elezioni-comunali" },
    { name: "Elezioni Regionali", path: "/elezioni-regionali" },
    { name: "Programma Regionale", path: "/programma-regionale" },
    { name: "La Storia", path: "/storia" },
    { name: "I Nostri Valori", path: "/valori" },
    { name: "Trasparenza", path: "/elezioni-trasparenti" },
    { name: "Unisciti a noi", path: "/unisciti" }
  ];

  return (
    <footer className="bg-[#002060] text-white" data-testid="main-footer">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <img 
                src={siteInfo.logo} 
                alt={siteInfo.name}
                className="h-20 w-20 rounded-full object-cover border-2 border-[#5CB9E5]"
              />
              <div>
                <h2 className="font-serif text-3xl md:text-4xl font-bold">
                  La Renaissance
                </h2>
                <p className="text-[#5CB9E5] font-medium">Valdôtaine</p>
              </div>
            </div>
            <p className="text-white/80 leading-relaxed mb-6 max-w-md">
              Movimento civico per la rinascita di Aosta e della Valle d'Aosta. 
              Partecipiamo attivamente all'evoluzione della società con responsabilità 
              e uno sguardo visionario.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-3">
              <a 
                href={siteInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/10 rounded-lg hover:bg-[#5CB9E5] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href={siteInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/10 rounded-lg hover:bg-[#5CB9E5] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href={siteInfo.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/10 rounded-lg hover:bg-[#5CB9E5] transition-colors"
                data-testid="footer-youtube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#FFD700]">
              Link Rapidi
            </h3>
            <nav className="flex flex-col gap-3">
              {quickLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className="text-white/80 hover:text-[#5CB9E5] transition-colors flex items-center gap-2"
                  data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <span className="w-1.5 h-1.5 bg-[#5CB9E5] rounded-full"></span>
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact & CTA */}
          <div>
            <h3 className="font-serif text-xl font-semibold mb-6 text-[#FFD700]">
              Contatti
            </h3>
            <div className="space-y-4 mb-8">
              <p className="flex items-start gap-3 text-white/80">
                <MapPin className="w-5 h-5 text-[#5CB9E5] flex-shrink-0 mt-0.5" />
                <span>Aosta, Valle d'Aosta<br />Italia</span>
              </p>
            </div>
            
            <Link 
              to="/unisciti"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#FFD700] text-[#002060] font-semibold rounded-lg hover:bg-[#FFD700]/90 transition-colors"
              data-testid="footer-join-cta"
            >
              Entra nella squadra
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} La Renaissance Valdôtaine. Tutti i diritti riservati.
            </p>
            <p className="text-white/60 text-sm">
              Movimento civico per la Valle d'Aosta
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
